
import { useEffect, useState } from 'react';

const Charts = ({ report }) => {
  const [chart, setChart] = useState(null);
  useEffect(() => {
    async function loadGoogleChart() {
      if (typeof window !== 'undefined') {
        const Chart = await import('react-google-charts');
        setChart(<Chart.Chart
          chartType="PieChart"
          data={data}
          options={options}
          width={"100%"}
          height={"400px"}
        />);
      }
    }
    setTimeout(() => loadGoogleChart(), 1000);
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const data = report.report.map(r => [r.fundName, parseInt(r.reportDayValuation)]);
  const sum = report.report.reduce((a, r) => a + parseInt(r.reportDayValuation), 0);
  data.unshift(['Fund', 'Amount']);
  const options = {
    title: `Total - ₹ ${sum}.00`,
    bars: "horizontal",
    is3D: true,
  };
  return (
    <>
      {chart}
    </>
  );
}
export default Charts;
